import jwtDecode from "jwt-decode";

export const SET_AUTH_TOKENS = "SET_AUTH_TOKENS";
export const SET_ALL_AUTH_VALUES = "SET_ALL_AUTH_VALUES";
export const UPDATE_ID_TOKEN = "UPDATE_ID_TOKEN";
export const UPDATE = "UPDATE";
export const RESET = "RESET";
export const STOP_TIMER = "STOP_TIMER";
export const SHOW_POPUP = "SHOW_POPUP";
export const HIDE_POPUP = "HIDE_POPUP";
export const SET_AUTH_VALUES_FROM_EVENT_RESP =
  "SET_AUTH_VALUES_FROM_EVENT_RESP";
export const TURN_ON_AUTH_DEBUG = "TURN_ON_AUTH_DEBUG";
export const TURN_OFF_AUTH_DEBUG = "TURN_OFF_AUTH_DEBUG";
export const SET_LAST_AUTH = "SET_LAST_AUTH";

export const updateTimer = (deltaTime) => ({
  type: UPDATE,
  deltaTime,
});

export const resetTimer = () => ({
  type: RESET,
});

export const stopAuthTimer = () => ({
  type: STOP_TIMER,
});

export const showPopup = () => ({
  type: SHOW_POPUP,
});

export const hidePopup = () => ({
  type: HIDE_POPUP,
});
export const hideAuthDebug = () => ({
  type: TURN_OFF_AUTH_DEBUG,
});
export const showAuthDebug = () => ({
  type: TURN_ON_AUTH_DEBUG,
});

export const turnOnAuthDebug = () => async (dispatch) => {
  dispatch(showAuthDebug());
};

export const turnOffAuthDebug = () => async (dispatch) => {
  dispatch(hideAuthDebug());
};

const requestSetAuthTokens = (token, refreshToken) => ({
  type: SET_AUTH_TOKENS,
  token,
  refreshToken,
});

const requestSetAllAuthValues = (token, refreshToken, iat, timeLeft) => ({
  type: SET_ALL_AUTH_VALUES,
  token,
  refreshToken,
  iat,
  timeLeft,
});

export const resetAuthTokenFromUserAction = (response) => {
  try {
    let decoded = jwtDecode(response.token);
    const timeLeft = (decoded.exp - decoded.iat) * 1000; //Comes back from server in seconds but needs to be miliseconds
    const iat = response.iat;
    const token = response.token;

    return {
      type: SET_AUTH_VALUES_FROM_EVENT_RESP,
      token,
      iat,
      timeLeft,
    };
  } catch (ex) {
    console.log("ERROR IN RESET AUTH TOKEN METHOD", ex, response.token);
    return {
      type: "FAILED_AUTH_RESET",
    };
  }
};

const requestUpdateIdToken = (token) => ({
  type: UPDATE_ID_TOKEN,
  token,
});

export const setAuthTokens = (token, refreshToken) => async (dispatch) => {
  dispatch(requestSetAuthTokens(token, refreshToken));
};

export const setAllAuthValues = () => async (dispatch) => {
  const token = localStorage.getItem("token");
  const refreshToken = localStorage.getItem("refreshToken");
  const iat = localStorage.getItem("iat");
  const timeLeft = localStorage.getItem("timeLeft");
  dispatch(requestSetAllAuthValues(token, refreshToken, iat, timeLeft));
};

export const updateIdToken = (token) => async (dispatch) => {
  dispatch(requestUpdateIdToken(token));
};



// WEBPACK FOOTER //
// ./src/actions/auth.js